import { ObjectHelper } from "../Helpers/ObjectHelper";
import { PartialNullable } from "../Extensions";
import { Property } from "../RadObject";
import { IPropertyComparer, PropertyComparer, PropertyComparerPropertyValues } from "./PropertyComparer";
import { NAMESPACE } from "./_Namespace";

export type PropertyComparerEqualsPropertyValues =
    PropertyComparerPropertyValues
    & {
    };

export type PropertyComparerEqualsProperties = {
    [name in keyof PropertyComparerEqualsPropertyValues]: Property<PropertyComparerEqualsPropertyValues[name]>
};

export interface IPropertyComparerEquals extends IPropertyComparer, PropertyComparerEqualsProperties
{
}

export class PropertyComparerEquals extends PropertyComparer<PropertyComparerEqualsPropertyValues> implements IPropertyComparerEquals
{
    public static override classNamespace = NAMESPACE + "PropertyComparerEquals";
    public static override className = "PropertyComparerEquals";

    // #region Constructor

    constructor(propertyValues?: PartialNullable<PropertyComparerEqualsPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    public override compare(propertyValue: any, constantValue: any): boolean
    {
        return ObjectHelper.compare(propertyValue, constantValue) === 0;
    }

    // #endregion
}
